// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoPlayerDefaultControls__controls-a7613f {
  background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 32px 8px;
}

.VideoPlayerDefaultControls__actions-panel-d2a62c {
  display: flex;
  justify-content: space-between;
}

.VideoPlayerDefaultControls__actions-f83da6 {
  display: flex;
  align-items: center;
  gap: 16px;
}

.VideoPlayerDefaultControls__action-button-f44332,
.VideoPlayerDefaultControls__action-button-f44332:focus {
  color: var(--addition-50);
}

.VideoPlayerDefaultControls__action-button-f44332:hover {
  color: var(--ib-color-hover); /* TODO: change design */
}

.VideoPlayerDefaultControls__progress-bd8c4b {
  height: 6px;
  margin: 13px 0;
  --progress-pin-size: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/VideoPlayer/VideoPlayerDefaultControls/VideoPlayerDefaultControls.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oEAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;;EAEE,yBAAA;AACF;;AAEA;EACE,4BAAA,EAAA,wBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EAEA,yBAAA;AAAF","sourcesContent":[".controls {\n  background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);\n  box-sizing: border-box;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 16px 32px 8px;\n}\n\n.actions-panel {\n  display: flex;\n  justify-content: space-between;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.action-button,\n.action-button:focus {\n  color: var(--addition-50);\n}\n\n.action-button:hover {\n  color: var(--ib-color-hover); /* TODO: change design */\n}\n\n.progress {\n  height: 6px;\n  margin: 13px 0;\n\n  --progress-pin-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": `VideoPlayerDefaultControls__controls-a7613f`,
	"actions-panel": `VideoPlayerDefaultControls__actions-panel-d2a62c`,
	"actionsPanel": `VideoPlayerDefaultControls__actions-panel-d2a62c`,
	"actions": `VideoPlayerDefaultControls__actions-f83da6`,
	"action-button": `VideoPlayerDefaultControls__action-button-f44332`,
	"actionButton": `VideoPlayerDefaultControls__action-button-f44332`,
	"progress": `VideoPlayerDefaultControls__progress-bd8c4b`
};
module.exports = ___CSS_LOADER_EXPORT___;
